<button
    [disabled]="disableCancel"
    mat-raised-button
    matTooltip="Cancel"
    (click)="handleCancel()"
>
    Cancel
</button>
<button
    [attr.data-testid]="'update_button'"
    [disabled]="disableUpdate"
    mat-raised-button
    matTooltip="Update Attribute"
    (click)="handleUpdate()"
>
    Update
</button>
<button
    [attr.data-testid]="'update_cascade_button'"
    [disabled]="disableCascade"
    mat-raised-button
    matTooltip="Update Attribute"
    type="button"
    (click)="handleUpdateItemCascade()"
>
    Update Cascade
</button>
<mat-checkbox
    *ngIf="locationSet !== 'Location' && !(newUpdateFlow$ | async)"
    (click)="handleForceOverrideInheritance($event)"
    #checkbox
    [checked]="isChecked"
>
    Force Change
    <br/>& Erase Overrides
</mat-checkbox>
